import { Component, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { ConfigService } from '@services/webFeeder/config.service';

@Component({
  selector: 'app-modal-auth-broker-login',
  templateUrl: './modal-auth-broker-login.component.html'
})
export class ModalAuthBrokerLoginComponent implements OnInit {

  isRequest = false;
  showpassword = false;
  isUserLogged = false;
  typeLogin: string;
  showDoubleAuthetication: boolean;
  loading: boolean;
  model: any = {};
  listQuestionDoubleAuthentication: any;
  questionActive: any = {};
  dataLoginDoubleAuth: any = {};
  subTitle: string;
  _dialog: MatDialog;
  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('snackBar', { read: ViewContainerRef }) parent: ViewContainerRef;

  constructor(
    public dialogRef: MatDialogRef<ModalAuthBrokerLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _authenticationService: AuthenticationService,
    private _configService: ConfigService,
    public _snackBar: CustomSnackbarService,
    private _router: Router,
    _dialog: MatDialog,
  ) {
    this._dialog = _dialog;
    this.typeLogin = this._configService.getLoginTypeEnabled();
    this.subTitle = 'Efetue o login novamente para utilizar os serviços de negociação!';
  }

  ngOnInit() {
  }

  logout() {
    this._dialog.closeAll();
    this._authenticationService.logout();
    this._configService.deleteHbBrokerUser();
    this._configService.deleteFavoriteThemeUser();
    this._configService.deleteAllCookie();
    this.dialogRef.close(false);
    this._configService._modalBuySellClosed.next(true);
    this._configService.REDIRECT_LOGOUT();
    window.sessionStorage.clear();
  }

  // closeClick(): void {
  //   this.dialogRef.close(false);
  // }

  // TODO: Aguardando definição da regra quando perde a sessao de negociação
  // login() {
  //   this.loading = true;
  //   if (!(this.model.username || this.model.password)) {
  //     this.setSnackBar();
  //     this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.info);
  //     this.loading = false;
  //   }
  //   this.tryLogin(this.model.username, this.model.password);
  // }

  // tryLogin(user: string, password: string) {
  //   try {
  //     this.getIp();
  //     if (!this.isRequest) {
  //       this.isRequest = true;
  //       const _user = new UserCA();
  //       if (Constants.LOGIN_TYPE.LoginW === this.typeLogin) {
  //         if (user && password) {
  //           this.model.username = this.model.username.trim();
  //           this.model.password = this.model.password.trim();
  //           _user.login = this.model.username;
  //           _user.password = this.model.password;
  //           if (isNaN(this.model.username)) {
  //             _user.profile = Profile.Assessor;
  //           } else {
  //             _user.profile = Profile.Client;
  //           }
  //         } else {
  //           this.setSnackBar();
  //           this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.error);
  //           this.loginForm.controls['password'].setErrors({ 'incorrect': true });
  //           this.loginForm.controls['username'].setErrors({ 'incorrect': true });
  //           this.isRequest = false;
  //         }
  //       } else {
  //         if (user && password) {
  //           user = user.trim();
  //           password = password.trim();
  //         } else {
  //           this.setSnackBar();
  //           this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.info);
  //           this.loginForm.controls['password'].setErrors({ 'incorrect': true });
  //           this.loginForm.controls['username'].setErrors({ 'incorrect': true });
  //           this.isRequest = false;
  //           this.loading = false;
  //           return false;
  //         }
  //         _user.login = user;
  //         _user.password = password;
  //       }
  //       this._authenticationService.login(_user.login, _user.password, _user.profile)
  //         .subscribe((data: any) => {
  //           if (data === 'INVALID_CREDENTIALS') {
  //             this.setSnackBar();
  //             this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG002, Constants.ALERT_TYPE.error);
  //             this.loginForm.controls['password'].setErrors({ 'incorrect': true });
  //             this.loginForm.controls['username'].setErrors({ 'incorrect': true });
  //             this.isRequest = false;
  //             this.loading = false;
  //           } else if (data.code) {
  //             this.setSnackBar();
  //             if (data.codeMessage === 'UNAUTHORIZED') {
  //               this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG002, Constants.ALERT_TYPE.error);
  //               this.loginForm.controls['password'].setErrors({ 'incorrect': true });
  //               this.loginForm.controls['username'].setErrors({ 'incorrect': true });
  //             } else {
  //               this._snackBar.createSnack(this.parent, data.message, Constants.ALERT_TYPE.error);
  //             }
  //             this.isRequest = false;
  //             this.loading = false;
  //           } else {
  //             // Dupla Autenticacao
  //             if (this.typeLogin === 'LoginO') {
  //               this._configService.setTokenApi(data.token);
  //               this._authServer.iNegotiation.getAfcSearchQuestions()
  //                 .subscribe(res => {
  //                   if (res.code === 0 && res.questions && res.questions.length > 0) {
  //                     this.model.questionType = '';
  //                     this.listQuestionDoubleAuthentication = res.questions;
  //                     const index = Math.floor(Math.random() * res.questions.length);
  //                     this.questionActive = res.questions[index];
  //                     this.questionActive.indexActived = [];
  //                     this.questionActive.questionResp = '';
  //                     this.questionActive.indexActived.push(index);
  //                     this.showDoubleAuthetication = true;
  //                     this.isRequest = false;
  //                     this.loading = false;
  //                     this.dataLoginDoubleAuth = [];
  //                     this.dataLoginDoubleAuth.push(data);
  //                     this.dataLoginDoubleAuth.push(_user);
  //                   }
  //                 },
  //                   error => {
  //                     this.setSnackBar();
  //                     this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
  //                     this.isRequest = false;
  //                     this.loading = false;
  //                   });
  //             } else {
  //               // this.setConfigLogin(data, _user);
  //             }
  //           }
  //         }, () => {
  //           this.setSnackBar();
  //           this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
  //           this.isRequest = false;
  //           this.loading = false;
  //         });
  //     }
  //   } catch (e) {
  //     this.setSnackBar();
  //     this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
  //     this.isRequest = false;
  //     this.loading = false;
  //   }
  // }

  // private getIp(timeoutErrorPostLogin = 3000) {
  //   const tryGetIp = () => {
  //     setTimeout(() => {
  //       this.getIp(timeoutErrorPostLogin * 1.5);
  //     }, timeoutErrorPostLogin);
  //   };
  //   this._authenticationService.getIp()
  //     .subscribe((resp) => {
  //       if (resp) {
  //         this._configService.setIP(resp);
  //       }
  //     }, (error) => {
  //       tryGetIp();
  //     });
  // }

  // setSnackBar() {
  //   const element = document.getElementById('snack-bar-msg');
  //   element.classList.add('active');
  //   element.style.visibility = 'visible';
  //   setTimeout(() => {
  //     if (element) {
  //       if (element.classList.contains('active')) {
  //         element.classList.remove('active');
  //       }
  //     }
  //   }, 8000);
  // }

  // togglePassword() {
  //   this.showpassword = !this.showpassword;
  // }

  // resetValidity(value) {
  //   if (value.key !== 'Enter') {
  //     let valueBefore = this.loginForm.controls['username'].value;
  //     this.loginForm.controls['username'].setValue(valueBefore);
  //     valueBefore = this.loginForm.controls['password'].value;
  //     this.loginForm.controls['password'].setValue(valueBefore);
  //     const snackDiv = document.getElementById('snack-bar-msg');
  //     if (snackDiv) {
  //       snackDiv.classList.remove('active');
  //       snackDiv.style.display = 'hidden';
  //     }
  //   }
  // }
}


